<template>

  <div id="map-wrapper" :class="colors.hoverClass">
    <div id="world-map" class="map">

      <transition name="fade"  mode="out-in">
        <svg id="wm" v-show="!loading"></svg>
      </transition>

      <transition name="fade"  mode="out-in">
        <Japan v-show="showJapan" />
      </transition>

      <transition name="fade"  mode="out-in">
        <InfoOverlay
        :text="mapLabels[$route.params.view].label"
        v-if="mapLabels[$route.params.view].show"
        @updateMapLabel="updateMapLabel"/>
      </transition>

    </div>
    <div class="info-wrapper">
      <div class="map-controls">
        <a @click="zoomOut" href="#">-</a>
        <a @click="zoomIn" href="#">+</a>
      </div>
      <div class="map-info">
        <p>In die Studie einbezogene Länder</p>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3';
import { mapState } from 'vuex';
import * as topojson from 'topojson';
import InfoOverlay from '@/components/InfoOverlay.vue';
import Japan from '@/components/Japan.vue';


export default {
  name: 'worldmap',
  components: {
    InfoOverlay,
    Japan,
  },
  computed: mapState([
    'worldmap',
    'mapLabels',
  ]),
  ready() {
  },
  data() {
    return {
      loading: true,
      container: {
        width: 0,
        height: 230,
      },
      showJapan: false,
    };
  },
  watch: {
    worldmap(v, o) {
      this.drawMap(v);
    },
    countries(v, o) {
      this.updateCountries();
    },
    selectedCountries(v, o) {
      this.updateCountries();
    },
  },
  props: {
    links: Array,
    countries: null,
    label: String,
    colors: {},
    selectedCountries: Array,
  },
  mounted() {
    this.$store.dispatch('LOAD_WORLD_DATA');
    window.addEventListener('resize', this.resizeMap);

    const japan = this.$el.querySelector('#test');
  },
  methods: {

    updateMapLabel() {
      this.mapLabels[this.$route.params.view].show = 0;
      this.translateMap();
    },

    translateMap() {
      // let t = d3.zoomIdentity.translate(-300, -90).scale(2);
      const t = d3.zoomIdentity.translate(-140, -90).scale(2);

      this.svg.transition().duration(500).call(this.zoom.transform, t);
      this.svg.call(this.zoom);
    },

    setZoom() {
      const self = this;
      const { g } = this;
      const s = this.svg;

      function zoomed() {
        g.attr('transform', d3.event.transform);
        self.showJapan = true;

        //if (d3.event.transform.k === 2 && d3.event.transform.x === -140) self.showJapan = true;
        //else self.showJapan = false;
      }

      // set map move / zoom limits
      this.zoom = d3.zoom()
        .scaleExtent([1, 5])
        .translateExtent([[0, 0], [this.container.width, this.container.height]])
        .on('zoom', zoomed);

      this.svg.call(this.zoom);
    },

    resizeMap() {
      this.container.width = this.$el.offsetWidth;
      this.$el.querySelector('svg').style.width = this.container.width;
      this.$el.querySelector('svg').style.height = this.container.height;
    },

    getCountryById(cId) {
      return _.find(this.countries, (c) => {
        if (c.Id === cId) {
          return c;
        }
      });
    },

    zoomIn(e) {
      e.preventDefault();
      const svg = d3.select('#world-map svg');
      svg.transition()
        .duration(500)
        .call(this.zoom.scaleBy, 1.5);
    },

    zoomOut(e) {
      e.preventDefault();
      const svg = d3.select('#world-map svg');
      svg.transition()
        .duration(500)
        .call(this.zoom.scaleBy, 0.5);
    },

    /**
      show tooltip and set country name
    */
    showTooltip(cId) {
      const country = this.getCountryById(cId);

      if (!country) return;

      this.tooltip = (this.tooltip) ? this.tooltip : d3.select('body').append('div');
      this.tooltip.attr('class', 'tooltip');

      const tip = `<h5 id="tooltip"${  cId  }'>${  country.Land  }</h5>`

      this.tooltip.html(tip)
        .style('left', `${d3.event.pageX + 20 }px`)
        .style('top', `${d3.event.pageY - 20 }px`);

      this.tooltip.classed('is-active', true);
    },

    /**
      hide tooltip
    */
    hideTooltip() {
      if (this.tooltip) {
        this.tooltip.classed('is-active', false);
      }
    },

    updateCountries() {
      // clear countries
      _.forEach(this.$el.querySelectorAll('.default'), (el, i) => {
        el.classList.remove('default');
      });

      // set countries
      _.forEach(this.countries, (c, key) => {
        const land = this.$el.querySelector(`.cId-${c.Id}`);
        if (land) {
          land.classList.add('default');
          if (c.Id === 'jp') this.$el.querySelector('#japan').classList.add('default');
        }
      });

      _.forEach(this.$el.querySelectorAll('.active'), (el, i) => {
        el.classList.remove('active');
      });

      for (let i = 0; i <= 4; i += 1) {
        const old = this.$el.querySelector(`.activeLand-${i}`);
        if (old) {
          old.classList.remove(`activeLand-${i}`);
        }
      }

      _.forEach(this.selectedCountries, (c, i) => {
        if (this.colors.hoverClass === 'portrait' || this.colors.hoverClass === 'ranking') {
          const land = this.$el.querySelector(`.cId-${c.Id}`);
          if (land) {
            land.classList.add('active');
            if (c.Id === 'jp') this.$el.querySelector('#japan').classList.add('active');
          }
        } else {
          const index = i + 1;
          i += 1;
          const land = this.$el.querySelector(`.cId-${c.Id}`);
          if (land) {
            land.classList.add(`activeLand-${index}`);
            if (c.Id === 'jp') this.$el.querySelector('#japan').classList.add(`activeLand-${index}`);
          }
        }
      });
    },

    drawMap(europe, error) {
      if (!europe) return;

      const that = this;
      const { width } = this.container;
      const { height } = this.container;

      this.topology = topojson.feature(europe, europe.objects['map.geo']);
      this.svg = d3.select('#wm');
      this.projection = d3.geoMercator()
        .scale(75)
        .translate([225, 200]);


      this.ppath = d3.geoPath().projection(this.projection);
      this.g = this.svg.append('g');
      this.g.selectAll('path')
        .data(topojson.feature(europe, europe.objects['map.geo']).features)
        .enter()
        .append('path')
        .attr('class', (d) => {
          const cId = d.properties.iso_a2.toLowerCase();
          const cl = `land cId-${cId}`;
          return cl;
        })

        .attr('d', this.ppath)
        .on('mouseover', (d) => {
          const cId = d.properties.iso_a2.toLowerCase();
          this.showTooltip(cId);
        })

        .on('mouseout', () => {
          // const cId = d.properties.iso_a2.toLowerCase();
          this.hideTooltip();
        })

        .on('click touchstart', (d) => {
          const cId = d.properties.iso_a2.toLowerCase();
          this.$emit('setCountry', this.getCountryById(cId), d3.event);
        });

      // japan
      d3.select('#japan')
        .on('mouseover', () => {
          this.showTooltip('jp');
        })
        .on('mouseout', () => {
          this.hideTooltip();
        })
        .on('click touchstart', () => {
          this.$emit('setCountry', this.getCountryById('jp'), d3.event);
        });


      this.container.width = that.$el.querySelector('#world-map').clientWidth;
      this.container.height = that.$el.querySelector('#world-map').clientHeight;

      this.updateCountries();
      this.setZoom();
      this.resizeMap();

      this.$nextTick(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss">
.worldmap {
  margin: 20px 0;
  border: 1px solid black;
}

.japan-info {
  position: absolute;
  bottom: $padding-default/2;
  right: $padding-default/2;
  background-color: transparent !important;
  // width: 10px;
  // height: 10px;
}

.label {
  text-align: left;
  clear: both;
}

.map-controls {
  a {
    display: inline-block;
    margin-right: $padding-min;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    line-height: 13px;
    background-color: $color-white;
    color: $color-brand;
    border: 1px solid $color-brand;
    text-align: center;
    font-size: 18px;
    @extend .animateAll;
    @extend .fontBolt;

    &:hover {
      color: $color-white;
      background-color: $color-brand;
    }
  }
}
.info-wrapper {
  display: grid;
  grid-template-columns: 20% 80%;
  justify-content: start;
  align-items: center;
  text-align: left;
  margin: $padding-min/2 0 $padding-default;
}
.map-info {
  font-size: 12px;
  text-align: right;
  p {
    display: inline-block;
    margin-right: $padding-min;
  }
  span {
    display: inline-block;
    width: 30px;
    height: 10px;
    background-color: $color-grey-dark;
  }
}

.map-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.map {
  position: relative;
  height: 230px;
  width: 100%;
  overflow: hidden;
  border: 1px solid $color-border;
  border-radius: $border-radius;

  svg#wm {
    width:   100%;
    height: 100%;

  }

  svg {
    background-color: $color-map-bg;
    // @extend .animateOpacity;

    // &.visible {
      // opacity: 1;
    // }

    .land {
      fill: $color-grey;
      stroke: $color-map-stroke;
      stroke-width: .2;
      @extend .animateFill;

      &:hover {
        // fill: $color-grey;
      }

      &.default {
        fill: $color-grey-dark;
        cursor: pointer;
      }

      // &:hover {
        // fill: $color-brand;
      // }

      // &.active {
        // fill: $color-brand;
      // }

    }
  }
}

</style>
